import React from 'react'
import _checkRoles from "../../../../helpers/checkRole";

function CustomersHead() {
    return (
        <thead className="CustomersHead CustomersHead--sticky">
            <tr>
                <th className="Stt">STT</th>
                <th className="Name">Mã KH</th>
                <th className="Name">Tên khách hàng</th>
                <th className="Name">Cụm parent</th>
                <th className="Address">Địa chỉ</th>
                <th className="Description">Hình thức</th>
                <th className="Source text-right">Hạn mức</th>
                <th className="Source">Sale</th>
                {_checkRoles('menu.customerhub.viewCustomer') && <th className="Actions"/>}
            </tr>
        </thead>
    )
}

export default CustomersHead
